/**
 * Created by Arif Topcu in 2019
 */

import React, { useCallback, useMemo } from "react";
import Combobox from "@ls/react-combobox-grid";
import ComplicationMiniSelector from "components/ComplicationMiniSelector";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "state/issueCount/selectors";
import { setDefinition, setDefinitions } from "state/issueCount/actions";
import IssueCountDefinition from "state/issueCount/IssueCountDefinition";
import Options from "state/issueCount/Options";
import { Cell, Grid } from "styled-css-grid";
import { summaryTypeOptionsLegacy } from "state/selections/Constants/SummaryType";

const issueCountDefinitionTypeOptions = Options.map((v) => ({
  label: v,
  value: v,
}));

const IssueCountComplication = ({
  complicationDefinition: definition,
  setComplication: setDefinition,
}) => {
  const [setIssueCountType, setSummary] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setIssueCountType(value)),
      (value) => setDefinition(definition.setSummary(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell width={2}>
        <Combobox
          options={issueCountDefinitionTypeOptions}
          clearable={false}
          onChange={setIssueCountType}
          value={definition.issueCountType}
          label="Issue Count Type:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell>
        <Combobox
          options={summaryTypeOptionsLegacy}
          onChange={setSummary}
          value={definition.summary}
          label="Abs/Rel:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={100}
        />
      </Cell>
    </Grid>
  );
};

const IssueCountSelector = () => {
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const dispatch = useDispatch();

  const setComplicationDefinition = useCallback(
    (idx, def) => dispatch(setDefinition(idx, def)),
    [dispatch]
  );
  const setComplicationDefinitions = useCallback(
    (def) => dispatch(setDefinitions(def)),
    [dispatch]
  );
  return (
    <ComplicationMiniSelector
      selectedComplicationDefinitions={definitions}
      setComplicationDefinition={setComplicationDefinition}
      setComplicationDefinitions={setComplicationDefinitions}
      ComplicationDefinitionClass={IssueCountDefinition}
      Complication={IssueCountComplication}
      complicationTitle={"Issue Count"}
    />
  );
};

export default IssueCountSelector;
